var s = (i, o, e) => new Promise((c, a) => {
  var p = (t) => {
    try {
      r(e.next(t));
    } catch (n) {
      a(n);
    }
  }, d = (t) => {
    try {
      r(e.throw(t));
    } catch (n) {
      a(n);
    }
  }, r = (t) => t.done ? c(t.value) : Promise.resolve(t.value).then(p, d);
  r((e = e.apply(i, o)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function A(i) {
  return s(this, null, function* () {
    const {
      data: o
    } = yield f.post(
      "/designordercenter/productionOrder/aiOperation/getAiCancelList",
      i
    );
    return o;
  });
}
export {
  A as postGetAiCancelList
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/aiOperation/getAiCancelList/post.js
// module id = 1813
// module chunks = 67